import './FilePicker.less';
import React, {useState, useEffect} from 'react';
import __ from "../../i18n";
import TabbedView from '../../../bootstrap/components/tabbed-view/TabbedView';
import FileBrowseTool from "../../tools/file-browse/FileBrowseTool";
import FileUploadTool from "../../tools/file-upload/FileUploadTool";


export default function FilePicker(
    {
        FileUploadParcel,
        FileListParcel,
        maxFiles,
        maxFileSize,
        allowedMimeTypes,
        allowedExtensions,
        renderThumbnail,
        renderPlaceholder,
        getFileTitle,
        getFileError,
        getSelectedSummary,
        onDone,
        onCancel,
    }
) {

    return <div className="file-picker">
        <TabbedView tabs={[__('Upload'), __('Browse')]}>
            <FileUploadTool
                FileUploadParcel={FileUploadParcel}
                renderThumbnail={renderThumbnail}
                renderPlaceholder={renderPlaceholder}
                maxFiles={maxFiles}
                maxFileSize={maxFileSize}
                allowedMimeTypes={allowedMimeTypes}
                allowedExtensions={allowedExtensions}
                onDone={onDone}
                onCancel={onCancel}
            />
            <FileBrowseTool
                FileListParcel={FileListParcel}
                maxFiles={maxFiles}
                renderThumbnail={renderThumbnail}
                getFileTitle={getFileTitle}
                getFileError={getFileError}
                getSelectedSummary={getSelectedSummary}
                onDone={onDone}
                onCancel={onCancel}
            />
        </TabbedView>
    </div>;
}

